// extracted by mini-css-extract-plugin
export var avatarContainer = "_9n-0";
export var avatarTypingWave = "_9n-i";
export var gray = "_9n-f";
export var green = "_9n-c";
export var icon = "_9n-9";
export var image = "_9n-1";
export var lg = "_9n-6";
export var md = "_9n-5";
export var presenceDot = "_9n-b";
export var red = "_9n-d";
export var sm = "_9n-4";
export var status = "_9n-a";
export var typingDot = "_9n-h";
export var typingPill = "_9n-g";
export var xl = "_9n-7";
export var xs = "_9n-3";
export var xxl = "_9n-8";
export var xxs = "_9n-2";
export var yellow = "_9n-e";